import Vue from 'vue'
import App from './App.vue'
// 路由声明
import router from "./router"
// element声明
import ElementUI from 'element-ui'
// element的组件声明
import 'element-ui/lib/theme-chalk/index.css'
// axios AJAX声明
import axios from 'axios'
// 全局校验的公共组件
import util from './common/util'
import './assets/styles/iconfont.css'
import './assets/styles/main.css'
import city from './assets/city.js'

// 插件
import plugins from '@/plugins';

Vue.use(ElementUI);
Vue.use(plugins);

// store
import store from '@/store/index';

Vue.config.productionTip = false
// var baseURL = 'https://jmmall.zxk.xm0592.com'
// var baseURL = 'http://127.0.0.1/vmwarebt/lxgyl/lxgyl_back/public';
// var baseURL = 'https://api.lx.xm0592.com'
var baseURL = 'https://lxapi.work.xm0592.com'

axios.defaults.baseURL = baseURL;

// 在请求或响应被 then 或 catch 处理前拦截它们 axios.interceptors.request 添加请求拦截器
axios.interceptors.request.use(config => {
    // 在发送请求之前做些什么
    // 读出存储在本地localStorage.token
    let token = localStorage.token
    // 判断是否存在token，如果存在的话，则每个http header都加上token
    if (token)
        // 每个端的authorization是不一样的 要改
        config.headers['Access-Token'] = token
    return config
})
// 添加响应拦截器axios.interceptors.response.use
axios.interceptors.response.use(response => {
    // 根据状态返回 Status Code: 200
    if (response.data.code == 1) {
        return response.data
    } else {
        if (!response.data.msg) {
            response.data.msg = response.data.message ? response.data.message : '请求异常'
        }

        ElementUI.Message.error({
            message: response.data.msg
        });
    }
    return Promise.reject(response.data.msg);
}, error => {
    // 根据状态码返回 在response中
    // 400是错误信息
    if (error.response.status == 400) {
        ElementUI.Message.error({
            message: error.response.data.msg
        });
        //	401 重复访问页面
    } else if (error.response.status == 401) {
        router.replace({path: '/'});
        //	402 绕过login直接访问后端页面
    } else if (error.response.status == 402) {
        // 清除本地所有缓存
        localStorage.clear()
        router.replace({path: '/login.html'});
    } else {
        ElementUI.Message.error({
            // 其他错误提示
            message: error.response.data.msg
        });
    }
    // 最后返回错误信息
    return Promise.reject(error.response.data.msg);
})
//给vue原型添加axios数据 = axios
Vue.prototype.axios = axios
//给vue原型添加app_url网址增加网址
Vue.prototype.app_url = baseURL

// 在全局添加一个方法 此处是检测
Vue.prototype.$check = util.formCheck
// 在全局中添加一个变量 都可以调用 此处是访问的数据时候的分页
Vue.prototype.pageSizeNume = 1000
Vue.prototype.page = 1
// 地区
Vue.prototype.$city = city;

//在全局路由钩子里面将页面滚动到页面顶部
router.beforeEach((to, from, next) => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
 
    // 兼容IE
    window.scrollTo(0, 0);
    next();
})
new Vue({
    render: h => h(App),
    store,
    router
}).$mount('#app')
